//! Camada de dados da geração de questão por IA (Sabiazinho-4).
import { API_URI } from "../../constants/consts";
import { api } from "../../services/apis/configs/axiosConfigs";

export interface GenerationContext {
	tema: string;
	contexto?: string;
	tipoQuestao: string; // "Questão objetiva" | "Questão dissertativa"
	nivelEscolaridade: string; // "Ensino Fundamental" | "Ensino Médio" | "Ensino Superior"
	nivelDificuldade: string; // "Fácil" | "Médio" | "Difícil"
	quantidadeAlternativas?: number;
	disciplina: string; // nome
	disciplina_id: string;
}

export interface GeneratedObjective {
	text: string;
	isCorrect: boolean;
	order: number;
}

export interface GeneratedQuestion {
	statement: string;
	disciplineId: string;
	disciplineName: string;
	educationLevel: string; // elementary | high_school | college
	difficultyLevel: string; // easy | medium | hard
	type: "objective" | "dissertative";
	keywords: string[];
	objectives: GeneratedObjective[];
	answerJustification: string;
}

const baseUrl = `${API_URI}/admin/private/questions/ai`;

export const questionGenerationAPI = {
	/** Retorna o prompt que será enviado — usado na tela de resumo. */
	preview: async function (
		context: GenerationContext,
		token: string
	): Promise<string> {
		const response = await api.request({
			url: `${baseUrl}/preview`,
			method: "POST",
			headers: { Authorization: `Bearer ${token}` },
			data: context,
		});
		return response.data?.data?.prompt ?? "";
	},

	/** Gera a questão via IA (não persiste). */
	generate: async function (
		context: GenerationContext,
		token: string
	): Promise<GeneratedQuestion> {
		const response = await api.request({
			url: `${baseUrl}/generate`,
			method: "POST",
			headers: { Authorization: `Bearer ${token}` },
			data: context,
		});
		return response.data?.data as GeneratedQuestion;
	},
};
